// extracted by mini-css-extract-plugin
module.exports = {"slot":"WordConnectables_slot__31R3E"};